// links.js

export const socialLinks = {
    Facebook: 'https://www.facebook.com/profile.php?id=61566675155483',
    Twitter: 'https://x.com/unknownpixelmed',
    Instagram: 'https://www.instagram.com/unknownpixelmedia/',
    Linkedin:'https://www.linkedin.com/company/unkownpixelmedia/'
  };
  
  export const navigationLinks = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '#services' },
    { label: 'Team', href: '#teams' },
    { label: 'About Us', href: '/about_us' },
    { label: 'Contact Us', href: '/contact_us' },
  ];
  